<template>
    <TrainingDashboard></TrainingDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TrainingDashboard = defineAsyncComponent(() =>
    import("../../components/Safety/TrainingDashboard/TrainingDashboard.vue")
);

export default {
    name: "Training_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { TrainingDashboard, AuthLayout },
};
</script>
